<template>
  <el-carousel height="480px" arrow="never" class="banner" :indicator-position="dataSouce.length > 1 ? '': 'none'">
    <el-carousel-item
      v-for="(item, index) in dataSouce"
      :key="'banner' + index"
    >
      <div class="banner-box" :style="{ 'background-image': `url(${item.image})` }">
        <div class="title">
          <h2>{{ item.title }}</h2>
          <div>
            <div class="big-button" @click="$router.push({ path: '/experience' })">立即体验</div>
          </div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "SolutionBanner",
  props: {
    dataSouce: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      banner: [
        {
          image: "https://cdn.ideamake.cn/sw-pc/images/banner/banner-group-02.png",
          title: "深耕城市，打造城市级标杆",
          link: "/index",
        },
        {
          image: "https://cdn.ideamake.cn/sw-pc/images/banner/banner-group-03.png",
          title: "深耕城市，打造城市级标杆",
          link: "/index",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.banner-box {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: 100% 480px;
  background-position: 50%;
  background-repeat: no-repeat;
  .title {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding-top: 180px;
    h2 {
      font-size: 42px;
      font-weight: 600;
      color: #ffffff;
      padding-bottom: 40px;
    }
  }
  .big-button {
    width: 132px;
    height: 48px;
    background: #3777f6;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    cursor: pointer;
    text-align: center;
    margin-top: 46px;
    &:hover {
      background: #5f92f8;
    }
  }
}
.banner {
  ::v-deep .el-carousel__indicators--horizontal {
    width: 1180px;
    bottom: 20px;
    .el-carousel__indicator {
      &.is-active {
        .el-carousel__button {
          background: #3777F6;
        }
      }
    }
    left: 20%;
    display: none;
  }
  ::v-deep .el-carousel__button {
    display: block;
    opacity: 1;
    width: 36px;
    height: 3px;
    background: #fff;
    position: relative;
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>